var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2991_41)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 20.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 37H19.5C17.019 37 15 34.981 15 32.5V17.5C15 15.019 17.019 13 19.5 13H30.5C32.981 13 35 15.019 35 17.5V32.5C35 34.981 32.981 37 30.5 37ZM19.5 14C17.57 14 16 15.57 16 17.5V32.5C16 34.43 17.57 36 19.5 36H30.5C32.43 36 34 34.43 34 32.5V17.5C34 15.57 32.43 14 30.5 14H19.5ZM31 18.5C31 18.224 30.776 18 30.5 18H24.5C24.224 18 24 18.224 24 18.5C24 18.776 24.224 19 24.5 19H30.5C30.776 19 31 18.776 31 18.5ZM31 24.5C31 24.224 30.776 24 30.5 24H24.5C24.224 24 24 24.224 24 24.5C24 24.776 24.224 25 24.5 25H30.5C30.776 25 31 24.776 31 24.5ZM31 30.5C31 30.224 30.776 30 30.5 30H24.5C24.224 30 24 30.224 24 30.5C24 30.776 24.224 31 24.5 31H30.5C30.776 31 31 30.776 31 30.5ZM21.5 20H19.5C19.224 20 19 19.776 19 19.5V17.5C19 17.224 19.224 17 19.5 17H21.5C21.776 17 22 17.224 22 17.5V19.5C22 19.776 21.776 20 21.5 20ZM20 19H21V18H20V19ZM21.5 26H19.5C19.224 26 19 25.776 19 25.5V23.5C19 23.224 19.224 23 19.5 23H21.5C21.776 23 22 23.224 22 23.5V25.5C22 25.776 21.776 26 21.5 26ZM20 25H21V24H20V25ZM21.5 32H19.5C19.224 32 19 31.776 19 31.5V29.5C19 29.224 19.224 29 19.5 29H21.5C21.776 29 22 29.224 22 29.5V31.5C22 31.776 21.776 32 21.5 32ZM20 31H21V30H20V31Z",
    fill: "#6A7988"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2991_41",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2991_41"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2991_41",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.bff505e6b9684434631f18828fb5a742.svg";
export { ForwardRef as ReactComponent };